<template>
  <div
    :id="id"
    class="ArticleImageWithTiles relative"
  >
    <ArticleImage
      :responsive-image="responsiveImage"
      :caption="caption"
      :credit="credit"
      :focal-point="focalPoint"
    />
    <ArticleProductTiles
      :id="id"
      :tiles="tiles"
    />
  </div>
</template>

<script>
export default {
  name: 'ArticleImageWithTiles',

  props: {
    responsiveImage: {
      type: Object,
      required: true,
    },

    focalPoint: {
      type: Object,
      required: true,
    },

    caption: {
      type: String,
      default: null,
    },

    credit: {
      type: String,
      default: null,
    },

    tiles: {
      type: Array,
      default: () => [],
    },

    id: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="postcss">
.ArticleImageWithTiles .ImageCaption {
  @screen lgMax {
    margin-bottom: 60px;
  }
}
</style>
